import React, { useEffect, useState } from "react";
import SellerSidebar from "./common/SellerSidebar";
import { Link, useParams } from "react-router-dom";
import ProfileSidebar from "../pages/common/ProfileSidebar";

function OrderDetail() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  const [courierName, setCourierName] = useState("");
  const [trackingNo, setTrackingNo] = useState("");
  const [trackingUrl, setTrackingUrl] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    // Dummy order data for now
    setOrder({
      id: "WT858589",
      date: "2025-08-09 11:30:20",
      status: "Pending",
      ip: "223.185.132.98",
      customerName: "Yon Lee",
      email: "yonlee13@gmail.com",
      group: "user",
      paymentMethod: "razorpay",
      billing:
        "Yon Lee, 123 Orchard Road, #05-678, Lucky Plaza, Singapore 238863, IN",
      shipping:
        "Yon Lee, 123 Orchard Road, #05-678, Lucky Plaza, Singapore 238863, IN",
      product: "Woolen Clothes for elders",
      productDate: "Aug, 28 2024 02:28:22 PM",
      quantity: 2,
      amount: "200.00 USD",
      payment: "Card",
      productStatus: "Confirmed",
      coupon: "PREPAID25",
      subtotal: "INR 9999",
      shippingCost: "INR 0",
      discount: "INR 2500",
      total: "INR 7499",
    });
  }, [orderId]);

  if (!order) return <p>Loading...</p>;

  const handleCourierSubmit = (e) => {
    e.preventDefault();
    if (courierName && trackingNo) {
      setIsSubmitted(true);
    }
  };

  return (
    <div className="all_suport_bg manages_top">
      <section className="ser_v_araeea profiles">
        <div className="container">
          {/* Breadcrumb */}
          <div className="bradcams">
            <span className="bothss">
              <Link to="">Dashboard</Link>{" "}
              <img src="/images/brd_rowwo.png" alt="" /> Store
              <img src="/images/brd_rowwo.png" alt="" /> Orders
              <img src="/images/brd_rowwo.png" alt="" /> Order Detail
            </span>
          </div>

          <div className="row">
            <div className="col-lg-3 mb_view_hide">
              <SellerSidebar />
            </div>

            <div className="col-lg-9">
              <h3 className="bulk-product-title mb-4">Order Detail</h3>

              <div className="row g-4">
                {/* Order Info */}
                <div className="col-md-6">
                  <div className="card p-3 shadow-sm">
                    <h5>Order #{order.id}</h5>
                    <p>
                      <strong>Order Date:</strong> {order.date}
                    </p>
                    <p>
                      <strong>Order Status:</strong> {order.status}
                    </p>
                    <p>
                      <strong>Placed from IP:</strong> {order.ip}
                    </p>
                  </div>
                </div>

                {/* Account Info */}
                <div className="col-md-6">
                  <div className="card p-3 shadow-sm">
                    <h5>Account Information</h5>
                    <p>
                      <strong>Customer Name:</strong> {order.customerName}
                    </p>
                    <p>
                      <strong>Email:</strong> {order.email}
                    </p>
                    <p>
                      <strong>Customer Group:</strong> {order.group}
                    </p>
                    <p>
                      <strong>Payment Method:</strong> {order.paymentMethod}
                    </p>
                  </div>
                </div>

                {/* Billing Address */}
                <div className="col-md-6">
                  <div className="card p-3 shadow-sm">
                    <h5>Billing Address</h5>
                    <p>{order.billing}</p>
                  </div>
                </div>

                {/* Shipping Address */}
                <div className="col-md-6">
                  <div className="card p-3 shadow-sm">
                    <h5>Shipping Address</h5>
                    <p>{order.shipping}</p>
                  </div>
                </div>

                {/* Products */}
                <div className="col-12">
                  <div className="card p-3 shadow-sm">
                    <h5>Order Item</h5>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>S. No.</th>
                          <th>Product Name</th>
                          <th>Date</th>
                          <th>Quantity</th>
                          <th>Amount</th>
                          <th>Payment</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>{order.product}</td>
                          <td>{order.productDate}</td>
                          <td>{order.quantity}</td>
                          <td>{order.amount}</td>
                          <td>{order.payment}</td>
                          <td className="text-success">
                            {order.productStatus}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Coupon & Comments */}
                <div className="col-md-6">
                  <div className="card p-3 shadow-sm">
                    <h5>Applied Coupon Code</h5>
                    <p>
                      <strong>Coupon Code:</strong> {order.coupon}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card p-3 shadow-sm">
                    <h5>Comments History</h5>
                    <p>Panel Content</p>
                  </div>
                </div>

                {/* Totals */}
                <div className="col-md-6">
                  <div className="card p-3 shadow-sm">
                    <h5>Order Totals</h5>
                    <p>
                      <strong>Subtotal:</strong> {order.subtotal}
                    </p>
                    <p>
                      <strong>Shipping:</strong> {order.shippingCost}
                    </p>
                    <p>
                      <strong>Coupon Discount:</strong> {order.discount}
                    </p>
                    <p>
                      <strong>Total:</strong> {order.total}
                    </p>
                  </div>
                </div>

                {/* Courier Details */}
                <div className="col-12">
                  <div className="card p-3 shadow-sm">
                    <h5>Courier Detail</h5>

                    {!isSubmitted ? (
                      <form onSubmit={handleCourierSubmit}>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label>Courier Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={courierName}
                              onChange={(e) => setCourierName(e.target.value)}
                              placeholder="Courier Name"
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Tracking No.</label>
                            <input
                              type="text"
                              className="form-control"
                              value={trackingNo}
                              onChange={(e) => setTrackingNo(e.target.value)}
                              placeholder="Tracking No."
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <label>Tracking URL</label>
                          <input
                            type="text"
                            className="form-control"
                            value={trackingUrl}
                            onChange={(e) => setTrackingUrl(e.target.value)}
                            placeholder="Tracking URL"
                          />
                        </div>
                        <div className="mb-3">
                          <label>Courier Description</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Description"
                          ></textarea>
                        </div>
                        <button type="submit" className="btn-submit">
                          Submit
                        </button>
                      </form>
                    ) : (
                      <div className="courier-summary">
                        <p>
                          This order has been shipped by{" "}
                          <strong>{courierName}</strong>
                        </p>
                        <p>
                          Tracking No.{" "}
                          <span className="tracking-no">{trackingNo}</span>
                        </p>
                        {trackingUrl && (
                          <p>
                            <a
                              href={trackingUrl}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Track Shipment
                            </a>
                          </p>
                        )}
                        {description && <p>{description}</p>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default OrderDetail;
